import React from 'react';
import { Box, Typography } from '@mui/material';
import { SkeletonLoader, TextBone } from '../../skeletons';

export type DataIndicatorWidgetProps = {
    label: string;
    value?: string | null;
    loading?: boolean;
};

export const DataIndicatorWidget: React.FunctionComponent<DataIndicatorWidgetProps> = function ({
    label,
    loading = false,
    value = '-',
}) {
    const labelStyle = {
        opacity: '0.6',
        fontSize: '17px',
        paddingBottom: '13px',
    };

    const valueStyle = {
        fontWeight: '500',
        fontSize: '24px',
    };

    return (
        <Box
            data-testid="DataIndicatorWidget-test-id"
            display="flex"
            flexDirection="column"
        >
            <Typography sx={labelStyle}>{label}</Typography>
            <SkeletonLoader
                isLoading={loading}
                skeleton={
                    <TextBone
                        textVariant="h6"
                        sx={valueStyle}
                    />
                }
            >
                <Typography sx={valueStyle}>{value ?? '-'}</Typography>
            </SkeletonLoader>
        </Box>
    );
};
